import {delay} from '@logistics-frontend/utils'

import {ServerError} from '../fetch'
import {FetchFunction} from '../types'

const ERROR_MESSAGE = 'Request has been terminated'
const MAX_RETRY_COUNT = 3

const withRequestHasBeenTerminatedRetry =
  <TReq = unknown, TRes = unknown, TExtraConfig extends Record<string, unknown> = {}>(
    fetchFunc: FetchFunction<TReq, TRes, TExtraConfig>,
  ): FetchFunction<TReq, TRes, TExtraConfig> =>
  config => {
    const retry = async (attempt: number = 0): ReturnType<FetchFunction<TReq, TRes, TExtraConfig>> => {
      try {
        return await fetchFunc(config)
      } catch (error: unknown) {
        if (error instanceof ServerError) {
          const isRequestHasBeenTerminatedError = error.status === 0 && error.message.includes(ERROR_MESSAGE)

          if (isRequestHasBeenTerminatedError && attempt < MAX_RETRY_COUNT) {
            return delay(1000).then(() => retry(attempt + 1))
          } else {
            throw isRequestHasBeenTerminatedError
              ? new Error('Кажется, что-то пошло не так! Попробуйте обновить страницу')
              : error
          }
        } else {
          throw error
        }
      }
    }

    return retry()
  }

export default withRequestHasBeenTerminatedRetry
